import React, { useEffect } from 'react';

const IfComponent = (props) => {
  //if condition is true then display your comp (as child) else null
  // usedfor - instead of writing turnery operator everytime
  const { isValid } = props;
  useEffect(() => {}, [isValid]);
  return <>{isValid ? props?.children : null}</>;
};

export default React.memo(IfComponent);
